<div
  (click)="disableDialog ? '' : dialogService.openUpsell()"
  matTooltip="{{ tooltip }}"
  class="w-[{{ size }}px] h-[{{ size }}px] bg-{{
    color
  }} rounded-full text-white cursor-pointer"
>
  <mat-icon class="scale-50 ml-[-2px] mt-[-2px]">star</mat-icon>
</div>
